const CTA_TYPE = {
	main: 'MAIN',
	farmFood: 'FARM_FOOD',
	local: 'LOCAL',
	pets: 'PETS',
	other: 'OTHER',
};

export default CTA_TYPE;